var _rect, _rect2, _rect3, _circle, _circle2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIndia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 16",
    width: 24,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    fill: "#ffffff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 5.333,
    fill: "#FF9933"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 10.667,
    width: 24,
    height: 5.333,
    fill: "#138808"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 8,
    r: 2.2,
    fill: "none",
    stroke: "#000080",
    strokeWidth: 0.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 8,
    r: 0.35,
    fill: "#000080"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000080",
    strokeWidth: 0.15
  }, /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 5.8,
    x2: 12,
    y2: 10.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.8,
    y1: 8,
    x2: 14.2,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.35,
    y1: 6.35,
    x2: 13.65,
    y2: 9.65
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.65,
    y1: 6.35,
    x2: 10.35,
    y2: 9.65
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.9,
    y1: 5.9,
    x2: 13.1,
    y2: 10.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.1,
    y1: 5.9,
    x2: 10.9,
    y2: 10.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.9,
    y1: 7.1,
    x2: 14.1,
    y2: 8.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.9,
    y1: 8.9,
    x2: 14.1,
    y2: 7.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndia);
export default __webpack_public_path__ + "static/media/india.63993af35485cfa030f84bad792a100f.svg";
export { ForwardRef as ReactComponent };